import { css } from '@emotion/react'

export const styles = {
  migrationContent: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 1rem;
    flex-wrap: wrap;
  `,
  migrationText: css`
    flex: 1;
    min-width: 0;
  `,
  migrationActions: css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
  `,
}
